import { Form, Grid, Row } from "antd";
import { Trans, useTranslation } from "react-i18next";
import { H2, H4, P1, P3 } from "../../../../../../components/NormalFonts";
import { handleClickCS } from "../../../../../../plugins/utils";
import { searchMode } from "../../../../enumerations/searchMode";
import { step } from "../../../../enumerations/step";
import styles from "./styleModule";

const FilterBarContainer = ({
  selectedSearchMode,
  setSelectedSearchMode,
  stepsEnum,
  steps,
  form,
}: {
  selectedSearchMode: string;
  setSelectedSearchMode: (value: string) => void;
  stepsEnum: any;
  steps: any;
  form: any;
}) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const getBottom = () => {
    if (screens.md) return "-260px";
    if (screens.xs) return "-210px";
    return "-320px"; // Default for xs or smaller
  };

  const getBodyPadding = () => {
    if (screens.lg) return "24px";
    else return "16px 10px";
  };

  const getWidth = () => {
    if (screens.xxl) return "calc(100% - 480px)";
    if (screens.md) return "calc(100% - 80px)";
    return "calc(100% - 32px)";
  };

  const headerEnum = [
    {
      key: searchMode.RESORT,
      title: t("home.searchbar.resortFirst"),
    },
    {
      key: searchMode.DATE,
      title: t("home.searchbar.dateFirst"),
    },
  ];

  return (
    <div
      className={styles.filterBarContainerWrapper}
      style={{
        bottom: getBottom(),
        margin: "0 auto",
        width: getWidth(),
      }}
    >
      <H2 weight="heavy" color="var(--primary)" className={styles.title}>
        {t("home.searchbar.title")}
      </H2>
      <H4
        weight="normal"
        color="var(--text-content-1)"
        className={styles.subtitle}
      >
        <Trans
          i18nKey={[
            `home.banner.subtitle.${process.env.REACT_APP_PROD_NAME_DEV}`,
            "home.banner.subtitle",
          ]}
        />
      </H4>
      <div className={styles.filterBarContainer}>
        <div className={styles.headerContainer}>
          {headerEnum.map((item) => (
            <div
              className={`${styles.titleWrapper} ${
                selectedSearchMode === item.key ? styles.selected : ""
              }`}
              onClick={() => setSelectedSearchMode(item.key)}
            >
              <P1 className={styles.title} weight={"normal"}>
                {item.title}
              </P1>
            </div>
          ))}
        </div>
        <div
          className={styles.bodyContainer}
          style={{
            padding: getBodyPadding(),
            width: stepsEnum[steps].bodyWidth,
          }}
        >
          <Form
            variant={screens.lg ? "filled" : "outlined"}
            style={{ width: "100%" }}
            autoComplete={"off"}
            onFinish={stepsEnum[steps].handleOk}
            form={form}
            requiredMark={steps === step.FULL_SEARCH}
            layout={"vertical"}
            initialValues={{ adults: "0", kids: "0" }}
          >
            <Row
              style={{ width: "auto" }}
              gutter={screens.lg ? [22, 0] : [12, 12]}
            >
              {stepsEnum[steps].content}
              {stepsEnum[steps].btn}
              {stepsEnum[steps].showHint && (
                <P3
                  className={styles.hint}
                  style={{
                    transform: screens.lg ? "translateX(50%)" : "unset",
                  }}
                >
                  {t("home.filterBar.hint")}
                  <span className={styles.cs}>
                    <a onClick={handleClickCS}>{t("normal.contactCS")}</a>
                  </span>
                </P3>
              )}
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default FilterBarContainer;
